__turbopack_context__.v({
  "checkbox": "q238rW_checkbox",
  "checkbox-input__loader": "q238rW_checkbox-input__loader",
  "checkbox__control": "q238rW_checkbox__control",
  "checkbox__label": "q238rW_checkbox__label",
  "switch": "q238rW_switch",
  "switch__control": "q238rW_switch__control",
  "switch__label": "q238rW_switch__label",
});
